import { PaginationButtons } from 'src/components'
import { useRemoveQuantityTypes } from 'src/hooks'

import { QuantityTypeCard } from './quantity-types-card.component'
import { AddQuantityTypeButton } from '../add-quantity-type-button.component'
import { IQuantityTypeBaseWithId } from 'src/types'

import { useStyles } from '../styles'

interface IQuantityTypesGridProps {
  quantityTypes?: IQuantityTypeBaseWithId[] | void
}

const QuantityTypesGrid = ({ quantityTypes }: IQuantityTypesGridProps) => {
  const { mutate: remove } = useRemoveQuantityTypes()
  const classes = useStyles()

  const handleDelete = (id: string) => async () => {
    remove([id])
  }

  return (
    <>
      <div className={classes.cardsWrapper}>
        {quantityTypes?.map((item) => (
          <QuantityTypeCard key={item.id} item={item} handleDelete={handleDelete(item.id)} />
        ))}
      </div>
      <AddQuantityTypeButton />
      <PaginationButtons buttonsOnly />
    </>
  )
}

export { QuantityTypesGrid }
